import General from '../tabs/settings/components/general/General/General'
import Hours from '../tabs/settings/components/hours/Hours'
import NewPersistentMenu from '../tabs/settings/components/persistentMenu/PersistentMenu'
import Integrations from '../tabs/settings/components/integrations/NewIntegrations'
import Users from '../tabs/settings/components/users/Users'
import Languages from '../tabs/settings/components/languages/Languages'
import TwoFactorAuth from '../tabs/settings/components/twoFactorAuth/TwoFactorAuth'
import AIFeaturesManagement from '../tabs/settings/components/aiFeaturesManagement/AIFeaturesManagement'
import SurveysSupervision from '../tabs/settings/components/surverysSupervision/SurveysSupervision'
import CreateSupervision from '../tabs/settings/components/createSupervision/CreateSupervision'
import EmailAutomation from '../tabs/settings/components/emailAutomation/EmailAutomation'
import RequestLimits from '../tabs/settings/components/requestLimits/RequestLimits'
export const settingsRoutes = [
  {
    path: 'general',
    name: 'General',
    component: General,
    isSubMenuRoute: true,
  },
  {
    path: 'languages',
    name: 'Languages',
    component: Languages,
    isSubMenuRoute: true,
  },
  {
    path: 'hours',
    name: 'Team Hours',
    component: Hours,
    isSubMenuRoute: true,
  },
  {
    path: 'users',
    name: 'Platform Admins',
    component: Users,
    isSubMenuRoute: true,
  },
  {
    path: 'integrations',
    name: 'Integrations',
    component: Integrations,
    isSubMenuRoute: true,
  },
  {
    path: 'persistent',
    name: 'Main Menu',
    component: NewPersistentMenu,
    isSubMenuRoute: true,
  },
  {
    path: 'twoFactorAuth',
    name: 'Two Factor Authentication',
    component: TwoFactorAuth,
    isSubMenuRoute: true,
  },
  {
    path: 'aiFeaturesManagement',
    name: 'AI Features Management',
    component: AIFeaturesManagement,
    isSubMenuRoute: true,
  },
  {
    path: 'surveysSupervision',
    name: 'Surveys & Supervision',
    component: SurveysSupervision,
    isSubMenuRoute: true,
  },
  {
    path: 'requestLimits',
    name: 'Usage limit tracking',
    component: RequestLimits,
    isSubMenuRoute: true,
  },
  {
    path: 'emailAutomation',
    name: 'Care Plan Automation',
    component: EmailAutomation,
    isSubMenuRoute: true,
  },
  {
    path: 'createSupervision/:templateId?',
    name: 'Create Supervision',
    component: CreateSupervision,
    isSubMenuRoute: false,
  },
]
